var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGift = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 11 11"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.403,
  d: "M9.167 3.667H1.833a.46.46 0 0 0-.458.458v.917c0 .253.205.458.458.458h7.334a.46.46 0 0 0 .458-.458v-.917a.46.46 0 0 0-.458-.458M5.5 3.667v5.958"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.403,
  d: "M8.708 5.5v3.208a.917.917 0 0 1-.916.917H3.208a.917.917 0 0 1-.916-.917V5.5M3.438 3.667a1.146 1.146 0 0 1 0-2.292c.442-.008.875.207 1.243.616s.653.993.819 1.676c.166-.683.451-1.267.82-1.676.367-.409.8-.624 1.243-.616a1.146 1.146 0 0 1 0 2.292"
})));
export default SvgGift;